module.exports = __webpack_public_path__ + "img/rgzn.d40926d.png";